import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { SocketContext } from "./SocketProvider.context";
import { ISocket } from "./SocketProvider.types";
import { IOrder } from "../../redux/orders";
import { useAuthProvider } from "../Authentication";
import { useOutletContext } from "../OutletContext";

export function useSocketContext() {
  const context = React.useContext(SocketContext);
  if (!context) throw new Error("SocketContext: Context must be used inside AuthProvider");
  return context;

}

export const useOrderContext = (socket: ISocket, playNotificationSound: () => void) => {
  const { authInfo: { user: userProfile } } = useAuthProvider()
  const { outlet_details: { outlet_uuid, outlet_name } } = useOutletContext()
  const [orderNotifications, setOrderNotifications] = useState<IOrder[]>([]);


  useEffect(() => {
    if (!socket || !outlet_uuid || !userProfile) return;  // ⬅️ WAIT until outlet_uuid exists

    const handleNewOrder = (nf: IOrder) => {
      console.log("New Order Received => ", {
        order: nf,
        outlet_uuid,
        outlet_name,
        userProfile,
        isPushed: nf.outlet_uuid === outlet_uuid && userProfile.role_value !== "USER",
        consition1: nf.outlet_uuid === outlet_uuid,
        consition2: userProfile.role_value !== "USER"
      });

      if (nf.outlet_uuid === outlet_uuid && userProfile.role_value !== "USER") {
        setOrderNotifications((prev) => [nf, ...prev]);
        playNotificationSound();
      }
    };

    socket.on("ORDER_RECEIVED", handleNewOrder);

    return () => {
      socket.off("ORDER_RECEIVED", handleNewOrder);
    };

  }, [socket, outlet_uuid, userProfile]);
  const onClearOrderNotification = (order_uuid: string) => {
    setOrderNotifications((prev) =>
      prev.filter((msg) => msg.order_uuid !== order_uuid)
    );
  };

  return useMemo(
    () => ({
      order_notifications: orderNotifications,
      onClearOrderNotification,
    }),
    [orderNotifications]
  );
};